export const transformStates = states =>
  states.map(({ long, short }) => `${long}, ${short}`)
